import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PromoComponent } from './promo.component';
import { PromoCreateComponent } from './promo-create/promo-create.component';
import { PromoEditComponent } from './promo-edit/promo-edit.component';
import { PromoFormComponent } from './shared/promo-form/promo-form.component';

import { PromoService } from './shared/promo.service';
import { FormsService } from '../shared/forms.service';
import { HttpService } from '../shared/http.service';
import { PromoAssignComponent } from './promo-assign/promo-assign.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  providers: [
    PromoService,
    FormsService,
    HttpService
  ],
  declarations: [ PromoComponent, PromoCreateComponent, PromoEditComponent, PromoFormComponent, PromoAssignComponent ]
})
export class PromoModule { }



// WEBPACK FOOTER //
// ./src/app/promos/promo.module.ts